export default __webpack_public_path__ + "static/media/oa_web_white.73d09859.svg";